import * as yup from 'yup';

const checkOutRequestSchema = yup.object().shape({
  requestedBy: yup.string().required('Requested By is required'),

  requestedByObject: yup
    .mixed()
    .nullable()
    .required('Requested By must be selected from the search results'),

  pickupLocation: yup.string().required('Pickup Location is required'),

  reason: yup.string().required('Reason Needed is required'),

  pickupDate: yup
    .date()
    .required('Pickup Date is required'),

  pickupTime: yup
    .date()
    .required('Pickup Time is required'),

  comments: yup
    .string()
    .max(500, 'Comments cannot exceed 500 characters'),
});

export default checkOutRequestSchema;